import { Component, EventEmitter, Output } from '@angular/core';
import { CollaborationDataService } from '../../services/collaboration-data.service';

@Component({
  selector: 'app-collaboration-summary',
  templateUrl: './collaboration-summary.component.html',
  styleUrls: ['./collaboration-summary.component.scss'],
})
export class CollaborationSummaryComponent {
  @Output() editSection = new EventEmitter<string>();

  constructor(private collaborationDataService: CollaborationDataService) {}

  createCollaborationExpanded: boolean = true;
  datasetExpanded: boolean = false;
  partnersExpanded: boolean = false;

  get collaborationDetails() {
    const { name, description, objective } = this.collaborationDataService.collaborationDetails || {};
    return {
      name: name || '--',
      description: description || '--',
      objective: objective || '--',
    };
  }

  get datasetDetails() {
    return this.collaborationDataService.selectedDatasets;
  }

  get inviteDetails() {
    const { partnerEmail, partnerInviteMessage } = this.collaborationDataService.collaborationDetails || {};
    return {
      partners: partnerEmail?.join(', ') || '--',
      message: partnerInviteMessage || '--',
    };
  }

  onEditSection(section: string): void {
    this.editSection.emit(section);
  }
}
